<template>
  <div class="sub-content">
    <div>个人资料<span class='theme-color'>标记*为必填</span></div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="真实姓名：" prop="username">
        <el-input v-model="ruleForm.username"></el-input>
      </el-form-item>
      <el-form-item label="手机号：" prop="mobile">
        <el-input v-model="ruleForm.mobile"></el-input>
      </el-form-item>
      <el-form-item label="邮箱：" prop="email">
        <el-input v-model="ruleForm.email"></el-input>
      </el-form-item>
      <el-form-item label="公司：" prop="company">
        <el-input v-model="ruleForm.company"></el-input>
      </el-form-item>
      <el-form-item label="职位：" prop="position">
        <el-input v-model="ruleForm.position"></el-input>
      </el-form-item>
      <el-form-item label="国家" prop="region">
        <el-col :span='24'>
          <el-select v-model="ruleForm.region" placeholder="请选择活动区域" style="width: 100%;">
          <el-option label="中国" value="shanghai"></el-option>
          <el-option label="美国" value="beijing"></el-option>
        </el-select>
        </el-col>
      </el-form-item>
      <el-form-item label="省/直辖市：" prop="region">
          <el-select v-model="ruleForm.region" placeholder="请选择活动区域" style="width: 32%;">
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
        <el-select v-model="ruleForm.region" placeholder="请选择活动区域" style="width: 32%;">
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
        <el-select v-model="ruleForm.region" placeholder="请选择活动区域" style="width: 32%;">
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="详细地址：" prop="address">
        <el-input v-model="ruleForm.address"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "home",
  data() {
    return {
      ruleForm: {
        username: '',
        mobile: '',
        email: '',
        company: '',
        position: '',
        address: ''
      },
      rules: {
        username: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱地址", trigger: "blur" }],
        company: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        position: [{ required: true, message: "请输入职位", trigger: "blur" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue